import { render, staticRenderFns } from "./activity-list.vue?vue&type=template&id=5a56559b&scoped=true&"
import script from "./activity-list.vue?vue&type=script&lang=js&"
export * from "./activity-list.vue?vue&type=script&lang=js&"
import style0 from "./activity-list.vue?vue&type=style&index=0&id=5a56559b&lang=scss&scoped=true&"
import style1 from "./activity-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a56559b",
  null
  
)

export default component.exports